import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Typography from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Typography';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';

const styles = () => ({
  root: {},
});

/**
 * @deprecated Renamed for consistency. Please use BodyText* from /FacetDesign/Components/Text instead.
 */
const BodyText = ({
  className,
  classes,
  text,
  align,
  color,
}) => {
  return (
    <Typography
      className={classNames(classes.root, className)}
      variant={'h6'}
      weight={'bold'}
      component={'p'}
      color={color}
      align={align}
    >
      {text}
    </Typography>
  );
};

BodyText.defaultProps = {
  className: '',
  color: 'primaryGray',
  align: 'center',
};

BodyText.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  text: PropTypes.string.isRequired,
  color: PropTypes.string,
  align: PropTypes.string,
};

export default withStyles(styles)(BodyText);
